<script lang="ts">
  import { onDestroy, onMount } from 'svelte'

  import { loadStylesheet, sgVersion, showModal } from '#js/common/helpers'
  import type GameStatusDialogType from "#components/GameStatusDialog";

  import SVG_svelte from './SVG_svelte.svelte'

  import css from '#css/v9/cards/game-square-card.pcss.json'

  export let gameId: number
  export let status: number

  const statusStrings = [
    'wishlist',
    'playing',
    'beaten',
    'sleep'
  ]

  let realStatus = (window.gameStatus && window.gameStatus[gameId]) ?? status

  const onClick = (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    if (window.isLoggedIn) {
      // noinspection TypeScriptCheckImport
      import(`/dist/js/components/GameStatusDialog.js?${sgVersion()}`)
        .then(({ default: GameStatusDialog }: { default: typeof GameStatusDialogType }) => {
          // noinspection TypeScriptValidateTypes
          showModal(GameStatusDialog, {
            gameId: gameId.toString(),
            iconSet: 'colorable'
          })
        })
    } else {
      // noinspection TypeScriptCheckImport
      import(`/dist/js/components/Auth/AuthDialog.js?${sgVersion()}`)
        .then(({ default: AuthDialog }) => {
          AuthDialog.show()
        })
    }
  }

  const onStatusChanged = (e: CustomEvent) => {
    const detailId = parseInt(e.detail.gameId)
    if (detailId === gameId) {
      realStatus = e.detail.status
    }
  }

  onMount(() => {
    loadStylesheet('v9/cards/game-square-card')
    window.addEventListener('game-status-changed', onStatusChanged)
  })

  onDestroy(() => {
    window.removeEventListener('game-status-changed', onStatusChanged)
  })
</script>

<button
    type="button"
    class={css['status-button']}
    on:click={onClick}
    data-game-status-button
>
    {#if status >= 0}
        <SVG_svelte
            i={`game-status/colorable/${statusStrings[realStatus]}`}
            data-game-watch-icon="true"
            data-game-watch-icon-status={statusStrings[realStatus]}
        />
    {:else}
        <div data-game-watch-icon>
            <SVG_svelte i="sg-new/plus" adaptive/>
        </div>
    {/if}
</button>
